import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { EditPriorityMappingModalApp } from './main.tsx';
import type { AppProps } from './types.tsx';

const EditPriorityMappingModal = lazyForPaint<typeof EditPriorityMappingModalApp>(() =>
	import(/* webpackChunkName: "async-edit-priority-mapping-modal" */ './main').then(
		(module) => module.EditPriorityMappingModalApp,
	),
);

export const AsyncEditPriorityMappingModal = (props: AppProps): React.JSX.Element => (
	<Placeholder name="edit-priority-mapping-modal" fallback={null}>
		<EditPriorityMappingModal {...props} />
	</Placeholder>
);
